/**
 * Generated API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const EvidenceFilterType = {
    ThisRevision: 'THIS_REVISION',
    OtherRevision: 'OTHER_REVISION',
    OtherProduct: 'OTHER_PRODUCT'
} as const;
export type EvidenceFilterType = typeof EvidenceFilterType[keyof typeof EvidenceFilterType];

